import React from "react";

import Applet from "../../Applet";
import OnshapeNameMappingTable from "../../../../components/OnshapeNameMapping/OnshapeNameMappingTable";

class OnshapeNameMappingTableApplet extends Applet {

    render() {
        return <OnshapeNameMappingTable applet={this}
                               pageSize={this.state.PageSize}
                               placement={this.state.Placement}
                               columns={this.state.Columns}
                               title="Onshape Name Mapping"
                               enterpriseComponent={this.getEnterpriseComponent()}
                               sort={this.state.Sort}
                               menu={this.state.Menu}
                               rowHeight={this.state.RowHeight}
                               enableSort={true}
        />;
    }

    state= {
        Name: "DeveloperEventTableApplet",
        Menu: {
            options: [
                {
                    displayValue: "New Mapping",
                    value: "New Mapping",
                },
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 60,
        PageSize: {
            "default": 5,
            "xs": 3,
            "sm": 3,
            "md": 10,
            "lg": 10,
            "lx": 10,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "EmployeeName",
                },
                {
                    id: "OnshapeEmail",
                },
                {
                    id: "Actions",
                },
            ],
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "EmployeeName",
                width: 250,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Employee Name",
            },
            {
                id: "OnshapeEmail",
                width: 550,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Onshape Email",
            },
            {
                id: "Actions",
                width: 50,
                cellRenderer: "Action Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "",
                pinned: "right",
                hideable: false,
            }
        ],
        Sort: [
            {
                "Identifier": 1,
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "EmployeeName",
                    "DisplayName": "Employee Name",
                }],
            },
        ],
    }
}

export default OnshapeNameMappingTableApplet;
